import {getRandomId} from 'shared/web';

// A fresh id per opening: a late completion from a dismissed dialog must not close a reopened one.
export const getRegisterExternalOrderDialogId = (configurationId: string) =>
  `register-external-order-${configurationId}-${getRandomId()}`;
